/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { FC } from 'react';

import { icons } from '@assets/index';
import { Checkbox, Collapse, CollapsePanel } from '@components/common';

import { IReportsColumnsItem } from '../types';
import {
    WizardColumnsSelectionItemStyled,
    WizardColumnsSelectionItemTitleStyled,
    WizardColumnsSelectionListStyled,
} from './styled/WizardColumnsSelectionStyled';

interface IWizardColumnsSelectionItemProps {
    itemData: IReportsColumnsItem;
    isCollapse?: boolean;
}

const WizardColumnsSelectionItem: FC<IWizardColumnsSelectionItemProps> = ({ itemData, isCollapse }) => {
    const { items, ...currentItemData } = itemData;

    if (items && items.length > 0) {
        return (
            <WizardColumnsSelectionItemStyled>
                <Collapse icon={icons.arrowDownSmallIcon} iconSize={28}>
                    <CollapsePanel
                        isOpen
                        titleValue={<WizardColumnsSelectionItem isCollapse itemData={currentItemData} />}
                    >
                        <WizardColumnsSelectionListStyled isCollapse>
                            {items.map((el) => (
                                <WizardColumnsSelectionItem itemData={el} key={el.id} />
                            ))}
                        </WizardColumnsSelectionListStyled>
                    </CollapsePanel>
                </Collapse>
            </WizardColumnsSelectionItemStyled>
        );
    }

    return (
        <WizardColumnsSelectionItemStyled isCollapse={isCollapse}>
            <Checkbox checked={currentItemData.checked} disabled={currentItemData.permanentDisabled} />
            <WizardColumnsSelectionItemTitleStyled>{currentItemData.title}</WizardColumnsSelectionItemTitleStyled>
        </WizardColumnsSelectionItemStyled>
    );
};

export default WizardColumnsSelectionItem;
